import React, { Component, ErrorInfo, ReactNode } from "react";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import UnknownError from "../routes/pages/error/PageUnknownError";

interface Props {
  appInsights: ReactPlugin;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class AppInsightsErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false
  };

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.props.appInsights.trackException({
      exception: error,
      properties: {
        componentStack: errorInfo.componentStack
      }
    });
  }

  render() {
    if (this.state.hasError) {
      return <UnknownError />
    }

    return this.props.children;
  }
}